import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faMapMarkerAlt, faUsers } from '@fortawesome/free-solid-svg-icons';
import { stringToUrlEncoded } from '../../../Utils/Converters';
import { NavLink } from 'react-router-dom';

import './EventListItem.css';

function EventListItem(props) {
    const { id, name, date, venue, previewPicture, registrationCount, registrationLimit } = props;

    return (
        <Container className="page-section event clearfix">
            <div className="event-img mb-3 mb-lg-0 rounded"
                style={{ backgroundImage: !!previewPicture ? `url(${previewPicture})` : `url('/assets/generic_preview.jpg')` }}
            />
            <NavLink to={`/events/${id}/${stringToUrlEncoded(name)}`}>
                <div className="event-text left-0 text-center bg-faded p-5 rounded">
                    <h2 className="section-heading mb-4">{name}</h2>
                    <Row className="mb-3">
                        <Col md="4">
                            <FontAwesomeIcon icon={faCalendarAlt} size="2x" /><br />
                            {new Date(date).toLocaleString("hu")}
                        </Col>
                        <Col md="4">
                            <FontAwesomeIcon icon={faMapMarkerAlt} size="2x" /><br />
                            {venue}
                        </Col>
                        <Col md="4">
                            <FontAwesomeIcon icon={faUsers} size="2x" /><br />
                            {registrationLimit - registrationCount} szabad hely
                                </Col>
                    </Row>
                </div>
            </NavLink>
        </Container>
    );
}

export default EventListItem;